import { humanizeGB } from 'Decorators/SizeDecorator'

const nodesColumns = [
  { Header: 'Node', accessor: 'name' },
  { Header: 'Role', accessor: 'role' },
  { Header: 'Version', accessor: 'software_version' },
  { Header: 'Node Type', accessor: 'platform_info.NodeType'},
  { Header: 'Raw Capacity TB', accessor: 'raw_node_size_tb'},
  { Header: 'Usable Capacity TB', accessor: 'tb_usable_node_size'},
  { Header: 'Drives', accessor: 'extra_info.num_drives'},
  { Header: 'Drive Capacity TB', accessor: 'extra_info.slice_drive_size_bytes', Cell: ({ value }) => (value / Math.pow(1000, 4)).toFixed(2)},
  { Header: 'Memory (in GB)', accessor: 'extra_info.memory_gb'}
]

const clusterColumns = [
  { Header: 'Cluster', accessor: 'name', type: 'link' },
  { Header: 'Location', accessor: 'location'},
  { Header: 'Node count', accessor: 'node_count'},
  { Header: 'Provisioned TB', accessor: 'provisioned_tb'},
  { Header: 'Total Block Storage TB', accessor: 'total_block_storage_tb'},
  { Header: 'TB usable before error', accessor: 'tb_usable_before_error'},
  { Header: 'TB usable to warning', accessor: 'tb_usable_to_warning'},
  { Header: 'Used Block Storage TB', accessor: 'used_block_storage_tb'},
  { Header: 'Free Usable TB', accessor: 'free_usable_tb'},
  { Header: 'Percentage to error', accessor: 'percentage_to_error', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false },
  { Header: 'Percentage to warning', accessor: 'percentage_to_warning', rag: true, ragLimits: { red: 90, amber: 80 }, type: 'percent', valueIsSmaller: false }
]

const chartColumns = [
  { label: 'Node count', accessor: 'node_count'},
  { label: 'Provisioned TB', accessor: 'provisioned_tb'},
  { label: 'Total Block Storage TB', accessor: 'total_block_storage_tb'},
  { label: 'TB usable before error', accessor: 'tb_usable_before_error'},
  { label: 'TB usable to warning', accessor: 'tb_usable_to_warning'},
  { label: 'Used Block Storage TB', accessor: 'used_block_storage_tb'},
  { label: 'Free Usable TB', accessor: 'free_usable_tb'},
  { label: 'Percentage to error', accessor: 'percentage_to_error' },
  { label: 'Percentage to warning', accessor: 'percentage_to_warning' }
]

export { nodesColumns, clusterColumns, chartColumns }